import Image from 'next/image';

import { useLightBoxModal } from '@screens/Product/hooks/useLightBoxModal';
import { ID_SCHEMES_ATTRIBUTE } from '@shared/constants/keys';
import { useAppSelector } from '@shared/hooks/redux';
import { HoverMask } from '@shared/ui/HoverMask/HoverMask';
import { LightBoxModal } from '@widgets/LightBoxModal';

import { Caption } from '../Caption/Caption';
import { EmptyState } from '../EmptyState/EmptyState';
import cls from './Schemes.module.scss';

export const Schemes = () => {
  const values = useAppSelector((state) => state.product.data.props[ID_SCHEMES_ATTRIBUTE]?.values);

  const { openLightBoxModal, currentImgUrl, imageUrls, handleCloseLightBox, handleChangeCurrentImageUrl } =
    useLightBoxModal({ values });

  if (!values?.length) {
    return <EmptyState />;
  }

  return (
    <div>
      <Caption>Схемы</Caption>
      <div className={cls.grid}>
        {imageUrls.map((src) => (
          <div
            key={src}
            className={cls.item}
            onClick={handleChangeCurrentImageUrl(src)}
          >
            <HoverMask />
            <Image
              src={src}
              alt={''}
              fill
            />
          </div>
        ))}
      </div>
      {currentImgUrl && openLightBoxModal && (
        <LightBoxModal
          open={openLightBoxModal}
          onClose={handleCloseLightBox}
          currentImageUrl={currentImgUrl}
          imageUrls={imageUrls}
        />
      )}
    </div>
  );
};
